import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { motion } from 'framer-motion';
import { AlertTriangle, Plus } from 'lucide-react';
import { AuroraBackdrop } from '../AuroraBackdrop';
import { Sidebar } from './Sidebar';
import { Topbar } from './Topbar';
import { StudentDetailModal } from '../students/StudentDetailModal';
import { StudentFormModal } from '../students/StudentFormModal';
import { StudentsProvider, useStudents } from '../../contexts/StudentsContext';
function ShellBody() {
  const {
    students,
    error,
    openCreateForm
  } = useStudents();
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  return <div className="min-h-screen w-full" data-id="element-144" data-mp="19c4ox916jqob">
      <AuroraBackdrop data-id="element-145" data-mp="19b35ag63lvuz" />

      <Sidebar collapsed={collapsed} onToggleCollapsed={() => setCollapsed(value => !value)} mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} totalStudents={students.length} data-id="element-146" data-mp="199a4hhi625uw" />

      <Topbar onOpenMobileNav={() => setMobileOpen(true)} sidebarCollapsed={collapsed} data-id="element-147" data-mp="1p6nzkfh33tsa" />

      <main className={`px-4 pb-28 pt-6 transition-[margin] duration-300 sm:px-6 lg:pb-12 ${collapsed ? 'lg:ml-[84px]' : 'lg:ml-[264px]'}`} data-id="element-148" data-mp="1kf5ylrf29t7b">
        {error && <div role="alert" className="mb-5 flex items-start gap-3 rounded-2xl border border-amber-500/30 bg-amber-500/10 p-4" data-id="element-149" data-mp="1ai1fy1kfcfv9">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-amber-600" data-id="element-150" data-mp="282xhjdv3x4hk" />
            <div className="min-w-0 text-sm" data-id="element-151" data-mp="236ymj7f9wo86">
              <p className="font-semibold text-foreground" data-id="element-152" data-mp="1y6kpslj4h0pg">Firestore could not stream your records</p>
              <p className="mt-0.5 break-words text-muted-foreground" data-id="element-153" data-mp="1t8iwz8vw9n0s">{error}</p>
            </div>
          </div>}

        <Outlet data-id="element-154" data-mp="msqdmfnfedf0" />
      </main>

      {/* Floating quick action */}
      <motion.button type="button" onClick={openCreateForm} initial={{
      opacity: 0,
      scale: 0.8
    }} animate={{
      opacity: 1,
      scale: 1,
      y: [0, -6, 0]
    }} transition={{
      opacity: {
        duration: 0.3
      },
      scale: {
        duration: 0.3
      },
      y: {
        duration: 4.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }
    }} whileHover={{
      scale: 1.06
    }} whileTap={{
      scale: 0.96
    }} aria-label="Add student" className="fixed bottom-6 right-5 z-30 inline-flex h-14 items-center gap-2 rounded-2xl brand-gradient px-5 text-sm font-semibold text-white shadow-2xl shadow-indigo-500/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand focus-visible:ring-offset-2 focus-visible:ring-offset-background sm:bottom-8 sm:right-8" data-id="element-155" data-mp="ht43if2w9daf">
        <Plus className="h-5 w-5" data-id="element-156" data-mp="2i8oxnx2tpb7q" />
        <span className="hidden sm:inline" data-id="element-157" data-mp="2i9qao73eg7s3">Add Student</span>
      </motion.button>

      <StudentFormModal data-id="element-158" data-mp="23d92foqib99r" />
      <StudentDetailModal data-id="element-159" data-mp="23cpt2wex9t7c" />
    </div>;
}
export function DashboardShell() {
  return <StudentsProvider data-id="element-160" data-mp="28aiwxisr6b4g">
      <ShellBody data-id="element-161" data-mp="28cve3tqoshgg" />
    </StudentsProvider>;
}